import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const searchRegimeAssets = api(async function searchRegimeAssets({ search, regimeIds }) {
    return query(
        gql`
            query SearchRegimeAssets($search: String!, $regimeIds: [String]) {
                searchRegimeAssets(search: $search, regimeIds: $regimeIds) {
                    id
                    label
                    tag
                    facility
                    floor
                    space
                    facilityId
                    floorId
                    spaceId
                    regimeId
                    scheduleId
                    scheduleTitle
                }
            }
        `,
        { search, regimeIds },
        { returns: "searchRegimeAssets" }
    )
})
